import React, { useState } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import { AiOutlineFileText } from "react-icons/ai";
import Skeleton from "react-loading-skeleton";

import { Header } from "../../common";
import SearchUsers from "./components/SearchUsers";
import LeaveSummary from "./components/LeaveSummary";
import { LeaveOverview, WFHOverview } from "./components/LeaveOverview";
import { AiOutlineArrowLeft } from "react-icons/ai";
import {
  DateRangeLeaveList,
  DateRangeWFHList,
} from "./components/DateRangeLeaveList";
import moment from "moment";
const LeaveReportingView = ({
  userList,
  getEmployeeLeaveList,
  setShow,
  showLoader,
  employeeLeaveList,
  currentYear,

  employeeLeavesSummarySuccess,
  otherLeavesSummarySuccess,

  employeeLeavesSummary,
  otherLeavesSummary,

  getEmployeeLeavesSummary,
  getOtherLeavesSummary,
  employeeLeaveListSuccess,
  reset,
  setFilter,
  resetFilter,

  optionalHolidaySummarySuccess,
  getOptionalHolidayLeaveSummary,
  optionalHolidaySummary,
  hideLeaveSummary,
  dateRangeEmployeeLeaveList,
  dateRangeLeaveList,
  startDate,
  endDate,
  downloadLeaveReportingList,

  getWorkFromHomeReportingList,
  WFHReportingListSuccess,
  employeeWFHUser,
  employeeWFHList,
  dateRangeWFHList,
  downloadWorkFromHomeReportingList,

  reportingListCategory,
  setReportingListCategory,
}) => {
  // console.log("dateRangeLeaveList", dateRangeLeaveList);

  const [viewLeaveSummary, setViewLeaveSummary] = useState(false);
  const [type, setType] = useState("");
  // const [category, setCategory] = useState("");
  const showLeaveSummary = (data) => {
    setViewLeaveSummary(data);
  };

  /* const categorySelection = (data) => {
    //console.log(data);
    setCategory(data);
  }; */

  const typeSelection = (data) => {
    //console.log(data);
    setType(data);
  };

  const exportToExcel = () => {
    /* const startDateVal = moment(currentYear, "YYYY").startOf("year").format("YYYY-MM-DD");
    const endDateVal = moment(currentYear, "YYYY").endOf("year").format("YYYY-MM-DD"); */

    // console.log("employeeLeaveList", employeeLeaveList);
    // console.log("employeeWFHList", employeeWFHList);

    // console.log("type", type);

    const employeeId =
      type.value === "By Employee"
        ? reportingListCategory === "Work From Home"
          ? employeeWFHList[0].employeeId
          : employeeLeaveList[0].employeeId[0]
        : null;

    const data =
      type.value === "By Employee"
        ? {
            employeeId: employeeId,
            startDate: moment(currentYear, "YYYY")
              .startOf("year")
              .format("YYYY-MM-DD"),
            endDate: moment(currentYear, "YYYY")
              .endOf("year")
              .format("YYYY-MM-DD"),
          }
        : type.value === "By Date-Range"
          ? {
              startDate: moment(startDate).format("YYYY-MM-DD"),
              endDate: moment(endDate).format("YYYY-MM-DD"),
            }
          : null;

    // console.log("CSV Download", { reportingListCategory, type, data });

    return reportingListCategory === "Work From Home"
      ? downloadWorkFromHomeReportingList(data)
      : downloadLeaveReportingList(data);
  };

  return (
    <>
      {/* <Header label={"Leave Reporting"} Icon={AiOutlineFileText} /> */}
      <Header
        label={`${
          viewLeaveSummary
            ? reportingListCategory === "Work From Home"
              ? "WFH"
              : "Leave"
            : "Leave / WFH"
        } Reporting`}
        Icon={AiOutlineFileText}
      />
      <div className="leave__reporting main__body padding">
        <Container>
          <Row>
            <Col sm={12} lg={12}>
              {viewLeaveSummary ? (
                <div className="backButton">
                  <AiOutlineArrowLeft
                    size={18}
                    className="arrowLeft"
                    color="#d87d2e"
                    onClick={() => {
                      setViewLeaveSummary(false);
                      hideLeaveSummary();
                    }}
                  />
                  <p>Go To Filter</p>
                </div>
              ) : (
                <SearchUsers
                  userList={userList}
                  getEmployeeLeaveList={getEmployeeLeaveList}
                  getEmployeeLeavesSummary={getEmployeeLeavesSummary}
                  getOtherLeavesSummary={getOtherLeavesSummary}
                  getOptionalHolidayLeaveSummary={
                    getOptionalHolidayLeaveSummary
                  }
                  reset={reset}
                  showLeaveSummary={showLeaveSummary}
                  typeSelection={typeSelection}
                  // categorySelection={categorySelection}
                  dateRangeEmployeeLeaveList={dateRangeEmployeeLeaveList}
                  getWorkFromHomeReportingList={getWorkFromHomeReportingList}
                  reportingListCategory={reportingListCategory}
                  setReportingListCategory={setReportingListCategory}
                />
              )}
            </Col>
            {setShow &&
              (type.value === "By Employee" ? (
                <>
                  <Col sm={12} lg={12}>
                    {reportingListCategory ===
                    "Work From Home" ? null : employeeLeavesSummarySuccess ===
                        false ||
                      otherLeavesSummarySuccess === false ||
                      optionalHolidaySummarySuccess === false ? (
                      <div>
                        <Card className="mt-3">
                          <Card.Body>
                            <Row>
                              <Col sm={12} lg={6}>
                                <Skeleton width={150} />
                                <Skeleton count={9} />
                              </Col>
                              <Col sm={12} lg={6}>
                                <Skeleton count={10} />
                              </Col>
                            </Row>
                          </Card.Body>
                        </Card>
                      </div>
                    ) : (
                      <LeaveSummary
                        currentYear={currentYear}
                        employeeLeavesSummary={employeeLeavesSummary}
                        otherLeavesSummary={otherLeavesSummary}
                        optionalHolidaySummary={optionalHolidaySummary}
                      />
                    )}
                  </Col>
                  <Col sm={12} lg={12}>
                    {employeeLeaveListSuccess === false &&
                    WFHReportingListSuccess === false ? (
                      <div>
                        <Card className="mt-3">
                          <Card.Body>
                            <Row>
                              <Col>
                                <Skeleton height={"50px"} />
                              </Col>
                              {/* <Col sm={6}>
                              <Skeleton count={2} />
                            </Col> */}
                            </Row>
                            <Skeleton count={10} />
                          </Card.Body>
                        </Card>
                      </div>
                    ) : reportingListCategory === "Work From Home" ? (
                      <WFHOverview
                        employeeWFHUser={employeeWFHUser}
                        employeeWFHList={employeeWFHList}
                        currentYear={currentYear}
                        setFilter={setFilter}
                        resetFilter={resetFilter}
                        exportToExcel={exportToExcel}
                      />
                    ) : (
                      <LeaveOverview
                        employeeLeaveList={employeeLeaveList}
                        currentYear={currentYear}
                        setFilter={setFilter}
                        resetFilter={resetFilter}
                        exportToExcel={exportToExcel}
                      />
                    )}
                  </Col>
                </>
              ) : type.value === "By Date-Range" ? (
                reportingListCategory === "Work From Home" ? (
                  <DateRangeWFHList
                    dateRangeWFHList={dateRangeWFHList}
                    startDate={startDate}
                    endDate={endDate}
                    exportToExcel={exportToExcel}
                  />
                ) : (
                  <DateRangeLeaveList
                    dateRangeLeaveList={dateRangeLeaveList}
                    startDate={startDate}
                    endDate={endDate}
                    exportToExcel={exportToExcel}
                  />
                )
              ) : null)}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default LeaveReportingView;
